export const translations = [
  {
    id: 1,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 1,
    name: {
      en: "Example product",
      et: "Näidistoode",
      lv: "Example product",
      fi: "Esimerkki tuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "001",
    code2: "3711234567890",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 10,
    suggested_retail_price: 0,
    price_with_tax: 10,
    net_weight: 0.25,
    gross_weight: 0.34,
    length: 180,
    width: 180,
    height: 65,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 250,
    category_id: 1,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 52,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 0,
    addedby: "",
    changed: 1612440789,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 2,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Products",
      et: "Tooted",
      lv: "Products",
      fi: "Tuotteet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "products",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599471681,
    addedby: "prince.ajuobi@er",
    changed: 1612440795,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 3,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Translations",
      et: "Tõlked",
      lv: "Translations",
      fi: "Käännökset",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "translations",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599471722,
    addedby: "prince.ajuobi@er",
    changed: 1612440800,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 4,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Channels/Assortments",
      et: "Kanalid / sortimendid",
      lv: "Channels/Assortments",
      fi: "Kanavat/Valikoimat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "channelsAssortment",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599471780,
    addedby: "prince.ajuobi@er",
    changed: 1612440807,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 5,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Parameter Sets",
      et: "Parameetrite komplektid",
      lv: "Parameter Sets",
      fi: "Parametri sarjat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "parameterSets",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599471899,
    addedby: "prince.ajuobi@er",
    changed: 1612440824,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 6,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Brands",
      et: "Kaubamärgid",
      lv: "Brands",
      fi: "Brändit",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "brands",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599471922,
    addedby: "prince.ajuobi@er",
    changed: 1612440829,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 7,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Countries",
      et: "Riigid",
      lv: "Countries",
      fi: "Maat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "countries",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599471942,
    addedby: "prince.ajuobi@er",
    changed: 1612440834,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 8,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix Dimensions",
      et: "Maatriksdimensioonid",
      lv: "Matrix Dimensions",
      fi: "Matriisivariaatiot",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matDimesions",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599471978,
    addedby: "prince.ajuobi@er",
    changed: 1612440842,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 9,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Categories",
      et: "Tooteseeriad",
      lv: "Product Categories",
      fi: "Tuotesarjat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productCategories",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599472023,
    addedby: "prince.ajuobi@er",
    changed: 1612440848,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 10,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Families",
      et: "Tooteperekonnad",
      lv: "Product Families",
      fi: "Tuoteperheet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productFamilies",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599472052,
    addedby: "prince.ajuobi@er",
    changed: 1612440867,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 11,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Groups",
      et: "Tootegrupid",
      lv: "Product Groups",
      fi: "Tuoteryhmät",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productGroups",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599472132,
    addedby: "prince.ajuobi@er",
    changed: 1612440862,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 12,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Priority Groups",
      et: "Tähtsusgrupid",
      lv: "Priority Groups",
      fi: "Tärkeysryhmät",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "priorityGroups",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599472163,
    addedby: "prince.ajuobi@er",
    changed: 1612440873,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 13,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Suppliers",
      et: "Hankijad",
      lv: "Suppliers",
      fi: "Toimittajat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "suppliers",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599472186,
    addedby: "prince.ajuobi@er",
    changed: 1612440878,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 14,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Units",
      et: "Ühikud",
      lv: "Units",
      fi: "Yksiköt",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "units",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599472205,
    addedby: "prince.ajuobi@er",
    changed: 1612440882,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 15,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Classifiers",
      et: "Klassifikaatorid",
      lv: "Classifiers",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "classifiers",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599475123,
    addedby: "prince.ajuobi@er",
    changed: 1599828547,
    changedby: "erplysupport",
  },
  {
    id: 16,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Clear Filters",
      et: "Tühjenda filtrid",
      lv: "Clear Filters",
      fi: "Tyhjennät suodattimet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "clearFilters",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599477859,
    addedby: "prince.ajuobi@er",
    changed: 1612440938,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 17,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a product",
      et: "Uus toode",
      lv: "Add a product",
      fi: "Lisää tuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599477899,
    addedby: "prince.ajuobi@er",
    changed: 1612440889,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 18,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Code",
      et: "Kood",
      lv: "Code",
      fi: "Koodi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "code",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599478625,
    addedby: "prince.ajuobi@er",
    changed: 1612440895,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 19,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product name",
      et: "Toote nimetus",
      lv: "Product name",
      fi: "Tuotteen nimi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productName",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599478659,
    addedby: "prince.ajuobi@er",
    changed: 1612440900,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 20,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "English",
      et: "inglise",
      lv: "English",
      fi: "Englanti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "english",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599478696,
    addedby: "prince.ajuobi@er",
    changed: 1612440907,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 21,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Estonian",
      et: "eesti",
      lv: "Estonian",
      fi: "Viro",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "estonia",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599478740,
    addedby: "prince.ajuobi@er",
    changed: 1612440913,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 22,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Group",
      et: "Tootegrupp",
      lv: "Group",
      fi: "Ryhmä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "group",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599478846,
    addedby: "prince.ajuobi@er",
    changed: 1612440921,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 23,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "EAN / UPC",
      et: "EAN",
      lv: "EAN / UPC",
      fi: "EAN",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "code2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599478907,
    addedby: "prince.ajuobi@er",
    changed: 1612440926,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 24,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Status",
      et: "Staatus",
      lv: "Status",
      fi: "Tila",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "status",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599478944,
    addedby: "prince.ajuobi@er",
    changed: 1612440930,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 25,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Code 3",
      et: "Kood 3",
      lv: "Code 3",
      fi: "Koodi 3",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "code3",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599478966,
    addedby: "prince.ajuobi@er",
    changed: 1612440945,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 26,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Type",
      et: "Tüüp",
      lv: "Type",
      fi: "Tyyppi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "type",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479007,
    addedby: "prince.ajuobi@er",
    changed: 1612440950,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 27,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Supplier",
      et: "Hankija",
      lv: "Supplier",
      fi: "Toimittaja",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "supplier",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479042,
    addedby: "prince.ajuobi@er",
    changed: 1612440954,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 28,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Category",
      et: "Seeria",
      lv: "Category",
      fi: "Sarja",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "category",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479073,
    addedby: "prince.ajuobi@er",
    changed: 1612440958,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 29,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Priority group",
      et: "Tähtsusgrupp",
      lv: "Priority group",
      fi: "Tärkeysryhmä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "priorityGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479143,
    addedby: "prince.ajuobi@er",
    changed: 1612440964,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 30,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Manufacturer",
      et: "Tootja",
      lv: "Manufacturer",
      fi: "Valmistaja",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "manufacturer",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479199,
    addedby: "prince.ajuobi@er",
    changed: 1612449602,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 31,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Brand",
      et: "Kaubamärk",
      lv: "Brand",
      fi: "Brändi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "brand",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479224,
    addedby: "prince.ajuobi@er",
    changed: 1612441855,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 32,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Country of origin",
      et: "Päritolumaa",
      lv: "Country of origin",
      fi: "Alkuperämaa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "countryOfOrigin",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479268,
    addedby: "prince.ajuobi@er",
    changed: 1612440980,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 33,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Net Price",
      et: "Netohind",
      lv: "Net Price",
      fi: "Nettohinta",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "price",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479291,
    addedby: "prince.ajuobi@er",
    changed: 1612440987,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 34,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Cost",
      et: "Laohind",
      lv: "Cost",
      fi: "Omakustannushinta ",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "cost",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479305,
    addedby: "prince.ajuobi@er",
    changed: 1612442196,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 35,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "{TAX} rate",
      et: "KM-määr",
      lv: "VAT rate",
      fi: "ALV-määrä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "vatRate",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479335,
    addedby: "prince.ajuobi@er",
    changed: 1656322588,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 36,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Show in webshop",
      et: "Kuvatakse e-poes",
      lv: "Show in webshop",
      fi: "Näytä verkkokaupassa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "showInWebshop",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599479367,
    addedby: "prince.ajuobi@er",
    changed: 1612441006,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 37,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product ID",
      et: "Toote ID",
      lv: "Product ID",
      fi: "Tuote ID",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productID",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599481252,
    addedby: "prince.ajuobi@er",
    changed: 1612441013,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 38,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Description",
      et: "Tootekirjeldus",
      lv: "Product Description",
      fi: "Tuotteen kuvaus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productDescription",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599481788,
    addedby: "prince.ajuobi@er",
    changed: 1612441018,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 39,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Plain Text",
      et: "Tavatekst",
      lv: "Plain Text",
      fi: "Teksti -muoto",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "plainText",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599481834,
    addedby: "prince.ajuobi@er",
    changed: 1612441998,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 40,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Rich Text",
      et: "Vormindatud tekst",
      lv: "Rich Text",
      fi: "Rich Text -muoto",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "richText",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599481851,
    addedby: "prince.ajuobi@er",
    changed: 1612441943,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 41,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product info",
      et: "Tooteinfo",
      lv: "Product info",
      fi: "Tuoteinfo",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599481966,
    addedby: "prince.ajuobi@er",
    changed: 1612441060,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 42,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Long Description",
      et: "Pikem kirjeldus",
      lv: "Long Description",
      fi: "Pitkäkuvaus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "longDescription",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599482044,
    addedby: "prince.ajuobi@er",
    changed: 1612441055,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 43,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Long Text Description",
      et: "Pikem kirjeldus",
      lv: "Long Text Description",
      fi: "Pitkäkuvaus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "longTextDescription",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599482112,
    addedby: "prince.ajuobi@er",
    changed: 1612442028,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 44,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Cancel",
      et: "Tühista",
      lv: "Cancel",
      fi: "Peruuta",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "cancel",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599482157,
    addedby: "prince.ajuobi@er",
    changed: 1612441047,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 45,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Save",
      et: "Salvesta",
      lv: "Save",
      fi: "Tallenna",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "save",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599482172,
    addedby: "prince.ajuobi@er",
    changed: 1612441042,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 46,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Plain Text Description",
      et: "Kirjeldus tavatekstina",
      lv: "Plain Text Description",
      fi: "Kuvaus tekstinä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "plainTextDescription",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599482235,
    addedby: "prince.ajuobi@er",
    changed: 1612442107,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 47,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Code",
      et: "Tootekood",
      lv: "Product Code",
      fi: "Tuotekoodi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productCode",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599483333,
    addedby: "prince.ajuobi@er",
    changed: 1612442073,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 48,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Manual",
      et: "Kasutusjuhend",
      lv: "Product Manual",
      fi: "Käyttöohje",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productManual",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599485279,
    addedby: "prince.ajuobi@er",
    changed: 1612441032,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 49,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Select",
      et: "Vali",
      lv: "Select",
      fi: "Valitse",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "select",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486256,
    addedby: "prince.ajuobi@er",
    changed: 1612441069,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 50,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "New",
      et: "Uus",
      lv: "New",
      fi: "Uusi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "new",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486289,
    addedby: "prince.ajuobi@er",
    changed: 1612441083,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 51,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Edit",
      et: "Redigeeri",
      lv: "Edit",
      fi: "Muokkaa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "edit",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486316,
    addedby: "prince.ajuobi@er",
    changed: 1612441087,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 52,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Delete",
      et: "Kustuta",
      lv: "Delete",
      fi: "Poista",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "delete",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486331,
    addedby: "prince.ajuobi@er",
    changed: 1612441091,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 53,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Duplicate",
      et: "Klooni",
      lv: "Duplicate",
      fi: "Kopio",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "duplicate",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486352,
    addedby: "prince.ajuobi@er",
    changed: 1612441098,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 54,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add Items",
      et: "Lisa",
      lv: "Add Items",
      fi: "Lisää tuotteita",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addItems",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486434,
    addedby: "prince.ajuobi@er",
    changed: 1612441104,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 55,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Remove Selected",
      et: "Eemalda valitud",
      lv: "Remove Selected",
      fi: "Poista valitut",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "removeSelected",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486459,
    addedby: "prince.ajuobi@er",
    changed: 1612441109,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 56,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Import From File",
      et: "Impordi failist",
      lv: "Import From File",
      fi: "Tuo tiedostosta",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "importFromFile",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486752,
    addedby: "prince.ajuobi@er",
    changed: 1612441116,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 57,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Channel/Assortment",
      et: "Kanal / sortiment",
      lv: "Channel/Assortment",
      fi: "Kanava/Valikoima",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "channelAssortment",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486876,
    addedby: "prince.ajuobi@er",
    changed: 1612441125,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 58,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Create",
      et: "Loo uus",
      lv: "Create",
      fi: "Luo uusi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "create",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599486940,
    addedby: "prince.ajuobi@er",
    changed: 1612441129,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 59,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "No",
      et: "Ei",
      lv: "No",
      fi: "Ei",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "no",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599487406,
    addedby: "prince.ajuobi@er",
    changed: 1612441133,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 60,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Yes",
      et: "Jah",
      lv: "Yes",
      fi: "Kyllä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "yes",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599487418,
    addedby: "prince.ajuobi@er",
    changed: 1612441137,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 61,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Confirm Message",
      et: "Kinnitussõnum",
      lv: "Confirm Message",
      fi: "Vahvistus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "confirmMessage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599487881,
    addedby: "prince.ajuobi@er",
    changed: 1612441142,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 62,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Are you sure you want to delete this record ?",
      et: "Kas oled kindel, et soovid selle kirje kustutada?",
      lv: "Are you sure you want to delete this record ?",
      fi: "Haluatko varmasti poistaa valitun?",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "confirmTextDelete",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599487922,
    addedby: "prince.ajuobi@er",
    changed: 1612441153,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 63,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Are you sure you want to remove this product(s) ?",
      et: "Kas soovid selle toote/need tooted eemaldada?",
      lv: "Are you sure you want to remove this product(s) ?",
      fi: "Oletko varma että haluat poistaa tuotteet?",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "confirmTextDeleteProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599488153,
    addedby: "prince.ajuobi@er",
    changed: 1612441165,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 64,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Name",
      et: "Nimetus",
      lv: "Name",
      fi: "Nimi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "name",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599488392,
    addedby: "prince.ajuobi@er",
    changed: 1612441169,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 65,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Details",
      et: "Detailid",
      lv: "Details",
      fi: "Yksityiskohdat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "details",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599488978,
    addedby: "prince.ajuobi@er",
    changed: 1612441181,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 66,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Link to product group",
      et: "Seo tootegrupiga",
      lv: "Link to product group",
      fi: "Linkitä tuoteryhmään",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "linkToProductGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599550641,
    addedby: "prince.ajuobi@er",
    changed: 1612442247,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 67,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add parameter set",
      et: "Uus parameetrite komplekt",
      lv: "Add parameter set",
      fi: "Lisää parametri sarja",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addParameterSet",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599550907,
    addedby: "prince.ajuobi@er",
    changed: 1612441199,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 68,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Parameter Set",
      et: "Parameetrite komplekt",
      lv: "Parameter Set",
      fi: "Parametrisarja",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "parameterSet",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599551447,
    addedby: "prince.ajuobi@er",
    changed: 1612442257,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 69,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Parameters in this set",
      et: "Parameetrid selles komplektis",
      lv: "Parameters in this set",
      fi: "Parametrit tässä sarjassa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "parametersInSet",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599551504,
    addedby: "prince.ajuobi@er",
    changed: 1612441212,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 70,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add parameter",
      et: "Uus parameeter",
      lv: "Add parameter",
      fi: "Lisää parametri",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addParameter",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599551537,
    addedby: "prince.ajuobi@er",
    changed: 1612441395,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 71,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Update",
      et: "Uuenda",
      lv: "Update",
      fi: "Päivitä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "update",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599551553,
    addedby: "prince.ajuobi@er",
    changed: 1612441388,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 72,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Close",
      et: "Sulge",
      lv: "Close",
      fi: "Sulje",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "close",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599552487,
    addedby: "prince.ajuobi@er",
    changed: 1612441384,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 73,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Parameter Options",
      et: "Parameetri valikuvariandid",
      lv: "Parameter Options",
      fi: "Parametrien vaihtoehdot",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "parameterOptions",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599552521,
    addedby: "prince.ajuobi@er",
    changed: 1612441379,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 74,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "View Options",
      et: "Vaata valikuvariante",
      lv: "View Options",
      fi: "Näytä vaihtoehdot",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "viewOptions",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599552557,
    addedby: "prince.ajuobi@er",
    changed: 1612441366,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 75,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add Parameter Option",
      et: "Uus valikuvariant",
      lv: "Add Parameter Option",
      fi: "Lisää parametrin valikko",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addParameterOption",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599552597,
    addedby: "prince.ajuobi@er",
    changed: 1612441360,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 76,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Loading",
      et: "Laadimine",
      lv: "Loading",
      fi: "Ladataan",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "loading",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599552759,
    addedby: "prince.ajuobi@er",
    changed: 1612441349,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 77,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Saving",
      et: "Salvestamine",
      lv: "Saving",
      fi: "Tallentaa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "saving",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599552779,
    addedby: "prince.ajuobi@er",
    changed: 1612441343,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 78,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a brand",
      et: "Uus kaubamärk",
      lv: "Add a brand",
      fi: "Lisää brändi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addABrand",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599553397,
    addedby: "prince.ajuobi@er",
    changed: 1612441338,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 79,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a country",
      et: "Uus riik",
      lv: "Add a country",
      fi: "Lisää maa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addACountry",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599553605,
    addedby: "prince.ajuobi@er",
    changed: 1612441329,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 80,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a dimension",
      et: "Uus dimensioon",
      lv: "Add a dimension",
      fi: "Lisää ominaisuusjoukko",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addADimension",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599640751,
    addedby: "prince.ajuobi@er",
    changed: 1612441323,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 81,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix dimension",
      et: "Maatriksdimensioon",
      lv: "Matrix dimension",
      fi: "Ominaisuusjoukko",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matrixDimension",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599640778,
    addedby: "prince.ajuobi@er",
    changed: 1612441314,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 82,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Please save matrix dimension first before you can view matrix values",
      et: "Dimensiooni väärtuste lisamiseks palun salvesta dimensioon.",
      lv: "Please save matrix dimension first before you can view matrix values",
      fi: "Tallenna matriisien ominaisuusjoukot ennen matriisin arvojen näkemistä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matrixViewMessage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599640914,
    addedby: "prince.ajuobi@er",
    changed: 1612441308,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 83,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "deleted successfully",
      et: "edukalt kustutatud",
      lv: "deleted successfully",
      fi: "poistettu onnistuneesti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "deletedSucces",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599641003,
    addedby: "prince.ajuobi@er",
    changed: 1612441274,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 84,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "added successfully",
      et: "edukalt lisatud",
      lv: "added successfully",
      fi: "lisätty onnistuneesti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addedSucces",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599641033,
    addedby: "prince.ajuobi@er",
    changed: 1612441260,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 85,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "updated successfully",
      et: "edukalt uuendatud",
      lv: "updated successfully",
      fi: "päivitetty onnistuneesti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "updatedSucces",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599641051,
    addedby: "prince.ajuobi@er",
    changed: 1612441254,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 86,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix values",
      et: "Dimensiooni väärtused",
      lv: "Matrix values",
      fi: "Ominaisuuksien arvot",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matrixValues",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599641406,
    addedby: "prince.ajuobi@er",
    changed: 1612441246,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 87,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add",
      et: "Lisa",
      lv: "Add",
      fi: "Lisää",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "add",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599642951,
    addedby: "prince.ajuobi@er",
    changed: 1612441239,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 88,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Categories",
      et: "Tooteseeriad",
      lv: "Categories",
      fi: "Sarjat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "categories",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599644582,
    addedby: "prince.ajuobi@er",
    changed: 1612441234,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 89,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Family",
      et: "Perekond",
      lv: "Family",
      fi: "Perhe",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "family",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599645102,
    addedby: "prince.ajuobi@er",
    changed: 1612441223,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 90,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Families",
      et: "Tooteperekonnad",
      lv: "Families",
      fi: "Tuoteperhe",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "families",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599645130,
    addedby: "prince.ajuobi@er",
    changed: 1612442375,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 91,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Archived",
      et: "Arhiveeritud",
      lv: "Archived",
      fi: "Arkistoitu",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "archived",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599645600,
    addedby: "prince.ajuobi@er",
    changed: 1612442385,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 92,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "You do not have sufficient permissions to view this page",
      et: "Sul ei ole selle lehekülje vaatamiseks piisavalt õigusi.",
      lv: "You do not have sufficient permissions to view this page",
      fi: "Ei riittäviä käyttöoikeuksia sivun katselemiseen",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "missingRight",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599645727,
    addedby: "prince.ajuobi@er",
    changed: 1612442443,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 93,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "First Name",
      et: "Eesnimi",
      lv: "First Name",
      fi: "Etunimi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "firstName",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650543,
    addedby: "prince.ajuobi@er",
    changed: 1612442451,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 94,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Bank Account Number",
      et: "Pangakonto",
      lv: "Bank Account Number",
      fi: "Pankkitili",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "bankAccNumber",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650620,
    addedby: "prince.ajuobi@er",
    changed: 1612442481,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 95,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Bank IBAN",
      et: "Panga IBAN",
      lv: "Bank IBAN",
      fi: "IBAN",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "bankIban",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650664,
    addedby: "prince.ajuobi@er",
    changed: 1612442487,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 96,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Bank Name",
      et: "Panga nimi",
      lv: "Bank Name",
      fi: "Pankin nimi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "bankName",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650692,
    addedby: "prince.ajuobi@er",
    changed: 1612442495,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 97,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Bank Swift",
      et: "Panga SWIFT",
      lv: "Bank Swift",
      fi: "SWIFT",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "bankSwift",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650710,
    addedby: "prince.ajuobi@er",
    changed: 1612442501,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 98,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Currency",
      et: "Valuuta",
      lv: "Currency",
      fi: "Valuutta",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "currency",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650732,
    addedby: "prince.ajuobi@er",
    changed: 1612442509,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 99,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Mail",
      et: "Meiliaadress",
      lv: "Mail",
      fi: "Sähköpostiosoite",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "mail",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650755,
    addedby: "prince.ajuobi@er",
    changed: 1612442533,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 100,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Mobile",
      et: "Mobiil",
      lv: "Mobile",
      fi: "Mobiilinro.",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "mobile",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650776,
    addedby: "prince.ajuobi@er",
    changed: 1612442662,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 101,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Phone",
      et: "Telefon",
      lv: "Phone",
      fi: "Puhelinnro.",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "phone",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650884,
    addedby: "prince.ajuobi@er",
    changed: 1612442582,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 102,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Notes",
      et: "Märkmed",
      lv: "Notes",
      fi: "Muistiinpanot",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "notes",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650897,
    addedby: "prince.ajuobi@er",
    changed: 1612442748,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 103,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Skype",
      et: "Skype",
      lv: "Skype",
      fi: "Skype",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "skype",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650935,
    addedby: "prince.ajuobi@er",
    changed: 1612442726,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 104,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "{TAX} Number",
      et: "KMKR",
      lv: "VAT Number",
      fi: "ALV-tunniste",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "vatNumber",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650969,
    addedby: "prince.ajuobi@er",
    changed: 1656322543,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 105,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Website",
      et: "Veebisait",
      lv: "Website",
      fi: "Verkkosivusto",
    },
    description: {
      en: {
        plain_text: "",
        html: "<p></p>\n",
      },
      et: {
        plain_text: "",
        html: "<p></p>\n",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "website",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599650989,
    addedby: "prince.ajuobi@er",
    changed: 1612442813,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 106,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a category",
      et: "Uus tooteseeria",
      lv: "Add a category",
      fi: "Lisää sarja",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addACategory",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599811756,
    addedby: "prince.ajuobi@er",
    changed: 1612442841,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 107,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a family",
      et: "Uus tooteperekond",
      lv: "Add a family",
      fi: "Lisää tuoteperhe",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addAFamily",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599811800,
    addedby: "prince.ajuobi@er",
    changed: 1612442849,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 108,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a priority group",
      et: "Uus tähtsusgrupp",
      lv: "Add a priority group",
      fi: "Lisää tärkeysryhmä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addAPriorityGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599811851,
    addedby: "prince.ajuobi@er",
    changed: 1612442879,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 109,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix dimension values",
      et: "Maatriksdimensiooni väärtused",
      lv: "Matrix dimension values",
      fi: "Matriisin ominaisuuksien arvot",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matrixDimensionValues",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599811903,
    addedby: "prince.ajuobi@er",
    changed: 1612442949,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 110,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a dimension value",
      et: "Uus dimensiooniväärtus",
      lv: "Add a dimension value",
      fi: "Lisää ominaisuuden arvo",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addADimensionValue",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599811936,
    addedby: "prince.ajuobi@er",
    changed: 1612441644,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 111,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a group",
      et: "Uus tootegrupp",
      lv: "Add a group",
      fi: "Lisää ryhmä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addAGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599812251,
    addedby: "prince.ajuobi@er",
    changed: 1612441636,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 112,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a supplier",
      et: "Uus hankija",
      lv: "Add a supplier",
      fi: "Lisää toimittaja",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addASupplier",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599812340,
    addedby: "prince.ajuobi@er",
    changed: 1612441631,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 113,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a unit",
      et: "Uus ühik",
      lv: "Add a unit",
      fi: "Lisää yksikkö",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addAUnit",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1599812440,
    addedby: "prince.ajuobi@er",
    changed: 1612441625,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 114,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Loading image",
      et: "Pildi laadimine",
      lv: "Loading image",
      fi: "Ladataan kuvaa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "loadingImage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600325880,
    addedby: "prince.ajuobi@er",
    changed: 1612441620,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 115,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Save Product Changes",
      et: "Salvesta toote muudatused",
      lv: "Save Product Changes",
      fi: "Tallenna muutokset",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "saveProductChanges",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600325909,
    addedby: "prince.ajuobi@er",
    changed: 1612441615,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 116,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Net sales price",
      et: "Netohind",
      lv: "Net sales price",
      fi: "Nettohinta",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "netSalesPrice",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326072,
    addedby: "prince.ajuobi@er",
    changed: 1612441609,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 117,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "EAN / UPC",
      et: "EAN",
      lv: "EAN / UPC",
      fi: "EAN",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "EANCode",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326184,
    addedby: "prince.ajuobi@er",
    changed: 1612441602,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 118,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Group",
      et: "Tootegrupp",
      lv: "Product Group",
      fi: "Tuoteryhmä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326285,
    addedby: "prince.ajuobi@er",
    changed: 1612441597,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 119,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Sales price + {tax}",
      et: "Hind km-ga",
      lv: "Sales price + VAT",
      fi: "Myyntihinta (sis.ALV)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "salesPriceAndVat",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326330,
    addedby: "prince.ajuobi@er",
    changed: 1656322515,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 120,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Tax rate (it is overridden by POS {tax} rate)",
      et: "KM-määr",
      lv: "Tax rate (it is overridden by POS VAT rate)",
      fi: "ALV %",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "vatRateOverriden",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326461,
    addedby: "prince.ajuobi@er",
    changed: 1656322491,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 121,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "{TAX} free in all locations",
      et: "Kõigis kauplustes käibemaksuvaba",
      lv: "VAT free in all locations",
      fi: "Verovapaa kaikissa myymälöissä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "vatFreeInAllLocation",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326520,
    addedby: "prince.ajuobi@er",
    changed: 1656322465,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 122,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Additional Product Groups",
      et: "Lisa-tootegrupid",
      lv: "Additional Product Groups",
      fi: "Muut tuoteryhmät",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "additionalProductGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326715,
    addedby: "prince.ajuobi@er",
    changed: 1612441543,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 123,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Manufacturer Code",
      et: "Tootja kood",
      lv: "Manufacturer Code",
      fi: "Valmistajan koodi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "manufacturerCode",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326781,
    addedby: "prince.ajuobi@er",
    changed: 1612441520,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 124,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Deposit fee",
      et: "Pandipakend",
      lv: "Deposit fee",
      fi: "Panttituote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "depositeFee",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326927,
    addedby: "prince.ajuobi@er",
    changed: 1612441512,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 125,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Fee quantity",
      et: "Pandipakendite arv",
      lv: "Fee quantity",
      fi: "Panttien määrä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "feeQuantity",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600326974,
    addedby: "prince.ajuobi@er",
    changed: 1612441506,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 126,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Usual delivery time",
      et: "Tarneaeg",
      lv: "Usual delivery time",
      fi: "Toimitusaika",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "usualDeliveryTime",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327032,
    addedby: "prince.ajuobi@er",
    changed: 1612441492,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 127,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Length (mm)",
      et: "Pikkus (mm)",
      lv: "Length (mm)",
      fi: "Pituus (mm)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "lengthmm",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327097,
    addedby: "prince.ajuobi@er",
    changed: 1612441476,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 128,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Width (mm)",
      et: "Laius (mm)",
      lv: "Width (mm)",
      fi: "Leveys (mm)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "widthmm",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327135,
    addedby: "prince.ajuobi@er",
    changed: 1612441470,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 129,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Height (mm)",
      et: "Kõrgus (mm)",
      lv: "Height (mm)",
      fi: "Korkeus (mm)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "heightmm",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327154,
    addedby: "prince.ajuobi@er",
    changed: 1612441463,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 130,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Weight (kg)",
      et: "Netomass (kg)",
      lv: "Weight (kg)",
      fi: "Paino (kg)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "weightkg",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327209,
    addedby: "prince.ajuobi@er",
    changed: 1612441928,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 131,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Gross weight (kg)",
      et: "Brutomass (kg)",
      lv: "Gross weight (kg)",
      fi: "Bruttopaino (kg)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "grossWeightkg",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327245,
    addedby: "prince.ajuobi@er",
    changed: 1612441921,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 132,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Volume (ml)",
      et: "Maht (ml)",
      lv: "Volume (ml)",
      fi: "Tilavuus (ml)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "volumeml",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327307,
    addedby: "prince.ajuobi@er",
    changed: 1612441911,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 133,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product does not need printed labels",
      et: "Tootele ei trükita etikette",
      lv: "Product does not need printed labels",
      fi: "Tämä tuote ei tarvitse tulostettua hintalappua",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "noPrintedLabels",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327475,
    addedby: "prince.ajuobi@er",
    changed: 1612441901,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 134,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Promotion discounts do not apply to this product",
      et: "Sellele tootele ei rakendu kampaania-allahindlused",
      lv: "Promotion discounts do not apply to this product",
      fi: "Tarjousalennukset eivät koske tätä tuotetta",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "promotionDiscount",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327530,
    addedby: "prince.ajuobi@er",
    changed: 1612441888,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 135,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Non-refundable product",
      et: "Toode ei ole tagastatav",
      lv: "Non-refundable product",
      fi: "Ei palautettava tuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "nonRefundable",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327582,
    addedby: "prince.ajuobi@er",
    changed: 1612441806,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 136,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "This product is a serial numbered gift card",
      et: "Toode on seerianumbriga kinkekaart",
      lv: "This product is a serial numbered gift card",
      fi: "Sarjanumerollinen lahjakortti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "serialNumbered",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600327677,
    addedby: "prince.ajuobi@er",
    changed: 1612441800,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 137,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Non-stock product or service",
      et: "Mitte-laotoode või teenus",
      lv: "Non-stock product or service",
      fi: "Ei-varastoitava tuote tai palvelu",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "nonStockProductOrService",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600328046,
    addedby: "prince.ajuobi@er",
    changed: 1612441791,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 138,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "This item does not grant customer reward points",
      et: "Selle toote ost ei anna püsikliendipunkte",
      lv: "This item does not grant customer reward points",
      fi: "Tästä tuotteesta ei kerry kanta-asiakaspisteitä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "noReward",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600328108,
    addedby: "prince.ajuobi@er",
    changed: 1612441783,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 139,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Cashier must enter price in POS",
      et: "Hinna sisestab kassiir",
      lv: "Cashier must enter price in POS",
      fi: "Hinta määritetään kassalla",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "priceInPOS",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600328531,
    addedby: "prince.ajuobi@er",
    changed: 1612441772,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 140,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Belongs to assortments",
      et: "Kuulub sortimentidesse",
      lv: "Belongs to assortments",
      fi: "Kuuluu valikoimaan",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "belongsToAssortments",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600328578,
    addedby: "prince.ajuobi@er",
    changed: 1612441756,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 141,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Parent product",
      et: "Peatoode",
      lv: "Parent product",
      fi: "Päätuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "parentProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600329618,
    addedby: "prince.ajuobi@er",
    changed: 1612441749,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 142,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Get product details with an API call",
      et: "Küsi toote andmeid API kaudu",
      lv: "Get product details with an API call",
      fi: "Hanki tuotetiedot API-kutsun avulla",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "apiCall",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600329672,
    addedby: "prince.ajuobi@er",
    changed: 1612441741,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 143,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "See API documentation",
      et: "Vaata API dokumentatsiooni",
      lv: "See API documentation",
      fi: "API-dokumentaatio",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "apiDocumentation",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600329815,
    addedby: "prince.ajuobi@er",
    changed: 1612441724,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 144,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Copy and paste the following command into a terminal window",
      et: "Kopeeri järgnev käsklus terminaliaknasse",
      lv: "Copy and paste the following command into a terminal window",
      fi: "Kopioi ja liitä seuraava käsky terminaalin ikkunaan",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "testApi",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600329887,
    addedby: "prince.ajuobi@er",
    changed: 1612441715,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 145,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "API Call Code",
      et: "API käsklus",
      lv: "API Call Code",
      fi: "API kutsu",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "apiCallCode",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600329937,
    addedby: "prince.ajuobi@er",
    changed: 1612441696,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 146,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Details",
      et: "Detailandmed",
      lv: "Product Details",
      fi: "Tuotteen yksityskohdat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productDetails",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600330966,
    addedby: "prince.ajuobi@er",
    changed: 1612441689,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 147,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Parameters",
      et: "Parameetrid",
      lv: "Parameters",
      fi: "Parametrit",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "parameters",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331037,
    addedby: "prince.ajuobi@er",
    changed: 1612441683,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 148,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Descriptions",
      et: "Kirjeldused",
      lv: "Descriptions",
      fi: "Kuvaukset",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "descriptions",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331103,
    addedby: "prince.ajuobi@er",
    changed: 1612441678,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 149,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Pictures",
      et: "Tootepildid",
      lv: "Product Pictures",
      fi: "Tuotteen kuvat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productPictures",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331148,
    addedby: "prince.ajuobi@er",
    changed: 1612441673,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 150,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Files",
      et: "Tootefailid",
      lv: "Product Files",
      fi: "Tuotteen tiedostot",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productFiles",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331178,
    addedby: "prince.ajuobi@er",
    changed: 1612441942,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 151,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Manuals",
      et: "Kasutusjuhendid",
      lv: "Manuals",
      fi: "Ohjeet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "manuals",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331223,
    addedby: "prince.ajuobi@er",
    changed: 1612441951,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 152,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Packages",
      et: "Pakendid",
      lv: "Packages",
      fi: "Pakkaukset",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "packages",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331254,
    addedby: "prince.ajuobi@er",
    changed: 1612441956,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 153,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Cross-Sell",
      et: "Seotud tooted",
      lv: "Cross-Sell",
      fi: "Liittyvät tuotteet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "crossSell",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331309,
    addedby: "prince.ajuobi@er",
    changed: 1612441967,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 154,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Substitutes",
      et: "Asendustooted",
      lv: "Substitutes",
      fi: "Korvaavat tuotteet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "substitutes",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331358,
    addedby: "prince.ajuobi@er",
    changed: 1612441975,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 155,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Attributes",
      et: "Atribuudid",
      lv: "Attributes",
      fi: "Ominaisuudet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "attributes",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331407,
    addedby: "prince.ajuobi@er",
    changed: 1612441979,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 156,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix",
      et: "Maatriks",
      lv: "Matrix",
      fi: "Matriisi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matrix",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331438,
    addedby: "prince.ajuobi@er",
    changed: 1612441985,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 157,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Recipe",
      et: "Retsept",
      lv: "Recipe",
      fi: "Resepti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "recipe",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331486,
    addedby: "prince.ajuobi@er",
    changed: 1612441989,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 158,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix Product",
      et: "Maatrikstoode",
      lv: "Matrix Product",
      fi: "Matriisituote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matrixProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600331723,
    addedby: "prince.ajuobi@er",
    changed: 1612441995,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 159,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Save Parameter Value",
      et: "Salvesta parameetri väärtus",
      lv: "Save Parameter Value",
      fi: "Tallenna parametrin arvo",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "saveParameterValue",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600333442,
    addedby: "prince.ajuobi@er",
    changed: 1612442003,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 160,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "This product does not have any parameters yet",
      et: "Sellel tootel ei ole parameetreid",
      lv: "This product does not have any parameters yet",
      fi: "Tällä tuotteella ei ole parametrejä määritelty",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "noParameter",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600333550,
    addedby: "prince.ajuobi@er",
    changed: 1612442011,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 161,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Link product group to a parameter set (select parameter set)",
      et: "Vali parameetrite komplekt, mida seostada selle toote tootegrupiga",
      lv: "Link product group to a parameter set (select parameter set)",
      fi: "Yhdistä tuoteryhmä parametri sarjaan (valitse parametrisarja)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "linkProductGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600333640,
    addedby: "prince.ajuobi@er",
    changed: 1612442042,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 162,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Save Descriptions",
      et: "Salvesta kirjeldused",
      lv: "Save Descriptions",
      fi: "Tallenna kuvaukset",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "saveDescriptions",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600333974,
    addedby: "prince.ajuobi@er",
    changed: 1612442049,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 163,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "saved successfully",
      et: "edukalt salvestatud",
      lv: "saved successfully",
      fi: "tallennus onnistui",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "savedSucces",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600334559,
    addedby: "prince.ajuobi@er",
    changed: 1612442055,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 164,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Authentication for image server failed",
      et: "Pildiserveriga autentimine ebaõnnestus",
      lv: "Authentication for image server failed",
      fi: "Yhteys kuvapalvelimeen epäonnistui",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "authImageFailed",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600334717,
    addedby: "prince.ajuobi@er",
    changed: 1612442093,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 165,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Error getting product image",
      et: "Pildi laadimine ebaõnnestus",
      lv: "Error getting product image",
      fi: "Virhe tuotekuvan haussa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "errorGettingImage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600334783,
    addedby: "prince.ajuobi@er",
    changed: 1612442106,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 166,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Could not initialize services",
      et: "Teenuste poole pöördumine ebaõnnestus",
      lv: "Could not initialize services",
      fi: "Palveluja ei voitu alustaa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "servicesFailed",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600334904,
    addedby: "prince.ajuobi@er",
    changed: 1612442114,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 167,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "An error occurred when retrieving the product. Please try again.",
      et: "Toote laadimine ebaõnnestus. Palun proovi uuesti.",
      lv: "An error occurred when retrieving the product. Please try again.",
      fi: "Virhe tuotteen haussa. Yritä uudelleen",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "errorGettingProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600335054,
    addedby: "prince.ajuobi@er",
    changed: 1650886560,
    changedby: "erplysupport",
  },
  {
    id: 168,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Open image",
      et: "Ava pilt",
      lv: "Open image",
      fi: "Avaa kuva",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "openImage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600335755,
    addedby: "prince.ajuobi@er",
    changed: 1612442127,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 169,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Large",
      et: "Suur",
      lv: "Large",
      fi: "Iso",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "large",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600335770,
    addedby: "prince.ajuobi@er",
    changed: 1612442133,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 170,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Medium",
      et: "Keskmine",
      lv: "Medium",
      fi: "Keskikokoinen",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "medium",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600335791,
    addedby: "prince.ajuobi@er",
    changed: 1612442193,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 171,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Small",
      et: "Väike",
      lv: "Small",
      fi: "Pieni",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "small",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600335801,
    addedby: "prince.ajuobi@er",
    changed: 1612442199,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 172,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Description",
      et: "Kirjeldus",
      lv: "Description",
      fi: "Kuvaus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "description",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600335858,
    addedby: "prince.ajuobi@er",
    changed: 1612442205,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 173,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Drag & Drop your pictures or",
      et: "Lohista pildid siia või",
      lv: "Drag & Drop your pictures or",
      fi: "Vedä ja pudota kuvat tai",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "dragAndDropPictures",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600336163,
    addedby: "prince.ajuobi@er",
    changed: 1612442223,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 174,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Browse",
      et: "Sirvi",
      lv: "Browse",
      fi: "Etsi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "browse",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600336229,
    addedby: "prince.ajuobi@er",
    changed: 1612442229,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 175,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Error uploading files, please try again",
      et: "Failide üleslaadimisel tekkis viga, palun proovi uuesti",
      lv: "Error uploading files, please try again",
      fi: "Virhe tiedostojen latauksessa, yritä uudelleen",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "errorUploadingFiles",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600336586,
    addedby: "prince.ajuobi@er",
    changed: 1612442247,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 176,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "File uploaded successfully",
      et: "Fail edukalt üles laaditud",
      lv: "File uploaded successfully",
      fi: "Tiedosto ladattu onnistuneesti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "fileUploadSucces",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600336649,
    addedby: "prince.ajuobi@er",
    changed: 1612442255,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 177,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Error loading files",
      et: "Failide laadimisel tekkis viga",
      lv: "Error loading files",
      fi: "Virhe tiedostojen lataamisessa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "errorLoadingFiles",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600336752,
    addedby: "prince.ajuobi@er",
    changed: 1612442265,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 178,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Authentication failed",
      et: "Autentimine ebaõnnestus",
      lv: "Authentication failed",
      fi: "Todennus epäonnistui",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "authFailed",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600336837,
    addedby: "prince.ajuobi@er",
    changed: 1612442273,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 179,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Drag & Drop your files or click to browse",
      et: "Lohista failid siia või klõpsa, et sirvida",
      lv: "Drag & Drop your files or click to browse",
      fi: "Vedä ja pudota tiedostot tai selaa napsauttamalla",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addFiles",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600337139,
    addedby: "prince.ajuobi@er",
    changed: 1612442283,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 180,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add More Files",
      et: "Lisa veel faile",
      lv: "Add More Files",
      fi: "Lisää tiedostoja",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addMoreFiles",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600337159,
    addedby: "prince.ajuobi@er",
    changed: 1612442320,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 181,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "File name",
      et: "Faili nimi",
      lv: "File name",
      fi: "Tiedoston nimi",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "fileName",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600337201,
    addedby: "prince.ajuobi@er",
    changed: 1612442328,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 182,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Edit product image",
      et: "Redigeeri tootepilti",
      lv: "Edit product image",
      fi: "Muokkaa tuotteen kuvaa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "editProductImage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600337521,
    addedby: "prince.ajuobi@er",
    changed: 1612442335,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 183,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: 'Here you can describe the usage instructions for this product. Alternatively, user manuals can also be uploaded as standalone documents in the "Product Files" section. ',
      et: "Siin on võimalik sisestada toote kasutusjuhised. Kui need on sul valmiskujul dokumendina olemas, võid need üles laadida „Tootefailide” alajaotuses.",
      lv: 'Here you can describe the usage instructions for this product. Alternatively, user manuals can also be uploaded as standalone documents in the "Product Files" section. ',
      fi: "Tässä voit kuvata tämän tuotteen käyttöohjeet. Vaihtoehtoisesti käyttöoppaat voidaan ladata myös erillisinä asiakirjoina Tuotetiedostot-osioon.",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "manualInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600337736,
    addedby: "prince.ajuobi@er",
    changed: 1612442377,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 184,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Save manuals",
      et: "Salvesta kasutusjuhendid",
      lv: "Save manuals",
      fi: "Tallenna käyttöoppaat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "saveManuals",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600337881,
    addedby: "prince.ajuobi@er",
    changed: 1612442384,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 185,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product manuals",
      et: "Kasutusjuhendid",
      lv: "Product manuals",
      fi: "Tuoteoppaat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productManuals",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600337976,
    addedby: "prince.ajuobi@er",
    changed: 1612442392,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 186,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Error updating manual",
      et: "Kasutusjuhendi uuendamine ebaõnnestus",
      lv: "Error updating manual",
      fi: "Virhe päivitettäessä käyttöopasta",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "errorUpdatingManual",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600338109,
    addedby: "prince.ajuobi@er",
    changed: 1612442406,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 187,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: 'For a general description of the product, we recommend to use the "Descriptions" section instead',
      et: "Tootele üldise kirjelduse omistamiseks on parem kasutada „Kirjelduste” alajaotust.",
      lv: 'For a general description of the product, we recommend to use the "Descriptions" section instead',
      fi: 'Yleistä tuotekuvausta varten suosittelemme käyttämään "Kuvaukset" -osaa',
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "manualInfo2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600338375,
    addedby: "prince.ajuobi@er",
    changed: 1612442438,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 188,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product package",
      et: "Pakend",
      lv: "Product package",
      fi: "Pakkaus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productPackage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600342422,
    addedby: "prince.ajuobi@er",
    changed: 1612442462,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 189,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a package",
      et: "Lisa pakend",
      lv: "Add a package",
      fi: "Lisää pakkaus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addAPackage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600342567,
    addedby: "prince.ajuobi@er",
    changed: 1612442468,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 190,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Amount",
      et: "Kogus",
      lv: "Amount",
      fi: "Määrä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "amount",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600342720,
    addedby: "prince.ajuobi@er",
    changed: 1612450671,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 191,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Net weight (kg)",
      et: "Netomass (kg)",
      lv: "Net weight (kg)",
      fi: "Nettopaino (kg)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "netWeight",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600342771,
    addedby: "prince.ajuobi@er",
    changed: 1612450406,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 192,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Gross weight(kg)",
      et: "Brutomass (kg)",
      lv: "Gross weight(kg)",
      fi: "Bruttopaino (kg)",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "grossWeight",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600342815,
    addedby: "prince.ajuobi@er",
    changed: 1612450413,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 193,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product(s) linked successfully",
      et: "Toode/tooted edukalt seostatud",
      lv: "Product(s) linked successfully",
      fi: "Tuote linkit päivitetty onnistuneesti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productLinkedSucces",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600343637,
    addedby: "prince.ajuobi@er",
    changed: 1612450645,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 194,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product link",
      et: "Viide tootele",
      lv: "Product link",
      fi: "Tuotteen linkki",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productLink",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600343843,
    addedby: "prince.ajuobi@er",
    changed: 1612450597,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 195,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add a cross-sell product",
      et: "Lisa seotud toode",
      lv: "Add a cross-sell product",
      fi: "Lisää liittyvä tuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "newRelatedProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600344021,
    addedby: "prince.ajuobi@er",
    changed: 1612450607,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 196,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Cross-sell products",
      et: "Seotud tooted",
      lv: "Cross-sell products",
      fi: "Liittyvät tuotteet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "crossSellProducts",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600344094,
    addedby: "prince.ajuobi@er",
    changed: 1612450616,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 197,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Unit",
      et: "Ühik",
      lv: "Unit",
      fi: "Yksikkö",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "unit",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600344269,
    addedby: "prince.ajuobi@er",
    changed: 1612443229,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 198,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "New replacement product",
      et: "Lisa asendustoode",
      lv: "New replacement product",
      fi: "Uusi korvaava tuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "newReplacementProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600344640,
    addedby: "prince.ajuobi@er",
    changed: 1612450624,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 199,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Search product",
      et: "Otsi toodet",
      lv: "Search product",
      fi: "Etsi tuotetta",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "searchProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600344699,
    addedby: "prince.ajuobi@er",
    changed: 1612443332,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 200,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product group is required",
      et: "Tootegrupp on kohustuslik",
      lv: "Product group is required",
      fi: "Tuoteryhmä on pakollinen",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productGroupRequired",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600344858,
    addedby: "prince.ajuobi@er",
    changed: 1612443624,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 201,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Substitute Products",
      et: "Asendustooted",
      lv: "Substitute Products",
      fi: "Korvaavat tuotteet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "substituteProducts",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600345055,
    addedby: "prince.ajuobi@er",
    changed: 1612450632,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 202,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add attribute",
      et: "Lisa atribuut",
      lv: "Add attribute",
      fi: "Lisää attribuutti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addAttribute",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600345372,
    addedby: "prince.ajuobi@er",
    changed: 1612443318,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 203,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "For an attribute with type “int” or “double”, the value must be a number",
      et: "„int” või „double” tüüpi atribuudi väärtus peab olema number",
      lv: "For an attribute with type “int” or “double”, the value must be a number",
      fi: "Attibuuttityyppien “int” tai “double” arvon on oltava numeroina.",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "operationDeniedAttributes",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600345607,
    addedby: "prince.ajuobi@er",
    changed: 1612443607,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 204,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product attribute",
      et: "Tooteatribuut",
      lv: "Product attribute",
      fi: "Tuoteattribuutti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productAttribute",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600345674,
    addedby: "prince.ajuobi@er",
    changed: 1612443221,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 205,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Value",
      et: "Väärtus",
      lv: "Value",
      fi: "Arvo",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "value",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600345971,
    addedby: "prince.ajuobi@er",
    changed: 1612443238,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 206,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product recipe",
      et: "Retsept",
      lv: "Product recipe",
      fi: "Resepti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productRecipe",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600346473,
    addedby: "prince.ajuobi@er",
    changed: 1612443249,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 207,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Bundle product",
      et: "Komplekt",
      lv: "Bundle product",
      fi: "Tuotepaketti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "bundleProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600346603,
    addedby: "prince.ajuobi@er",
    changed: 1612443175,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 208,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Assembly product",
      et: "Komplekteeritav toode",
      lv: "Assembly product",
      fi: "Kokoonpanotuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "assemblyProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600346632,
    addedby: "prince.ajuobi@er",
    changed: 1612443163,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 209,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: " A bundle does not have inventory. When selling a bundle, components are deducted from stock.",
      et: "Komplektil endal ei ole laoseisu. Komplekti müümisel arvestatakse laost maha selle koostisosad.",
      lv: " A bundle does not have inventory. When selling a bundle, components are deducted from stock.",
      fi: "Tuotepaketilla ei ole varastosaldoja. Myytyjen pakettien osat vähennetään varastosaldoista.",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "bundleInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600346711,
    addedby: "prince.ajuobi@er",
    changed: 1612443274,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 210,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "An assembly can be both purchased, and built from components on-site. Assembly products have inventory.",
      et: "Komplekteeritavat toodet saab nii ostuarvega lattu võtta kui ka koostisosadest valmistada. Komplekteeritaval tootel on laoseis.",
      lv: "An assembly can be both purchased, and built from components on-site. Assembly products have inventory.",
      fi: "Kokoonpainotuote voidaan rekisteröidä valmiina kokonaisuutena tai koostaa osista. Kokoonpanotuotteella ja sen osilla on varastosaldot. Kokoonpanotuotteen varastosaldot lisätään Varaston rekisteröinnillä. Järjestelmä päivittää automaattisesti osien varasto",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "assemblyInfo1",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600346790,
    addedby: "prince.ajuobi@er",
    changed: 1612450778,
    changedby: "maarit.jaatinen@",
  },
  {
    id: 211,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "To build assembly products, make an Inventory Registration. Erply will automatically deduct components from inventory and take the finished assembly into stock.",
      et: "Komplekteeritavaid tooteid saab komplekteerida arvelevõtu aktiga. Märgi aktil linnuke „Komplekteeri”; Erply võtab automaatselt komponendid laost maha ja võtab valmistoote lattu.",
      lv: "To build assembly products, make an Inventory Registration. Erply will automatically deduct components from inventory and take the finished assembly into stock.",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "assemblyInfo2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600346851,
    addedby: "prince.ajuobi@er",
    changed: 1601888098,
    changedby: "randma@erply.com",
  },
  {
    id: 212,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Component",
      et: "Komponent",
      lv: "Component",
      fi: "Komponentti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "component",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600346918,
    addedby: "prince.ajuobi@er",
    changed: 1612450829,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 213,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product",
      et: "Toode",
      lv: "Product",
      fi: "Tuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "product",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600347132,
    addedby: "prince.ajuobi@er",
    changed: 1612443168,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 214,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "removed successfully",
      et: "edukalt eemaldatud",
      lv: "removed successfully",
      fi: "poistettu onnistuneesti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "removedSucces",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600347155,
    addedby: "prince.ajuobi@er",
    changed: 1612450837,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 215,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Sales Price",
      et: "Müügihind",
      lv: "Sales Price",
      fi: "Myyntihinta",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "salesPrice",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600347311,
    addedby: "prince.ajuobi@er",
    changed: 1612443181,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 216,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Dimensions",
      et: "Dimensioonid",
      lv: "Dimensions",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "dimensions",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600347847,
    addedby: "prince.ajuobi@er",
    changed: 1601280076,
    changedby: "erplysupport",
  },
  {
    id: 217,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Save Dimensions",
      et: "Salvesta dimensioonid",
      lv: "Save Dimensions",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "saveDimensions",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600347979,
    addedby: "prince.ajuobi@er",
    changed: 1601280071,
    changedby: "erplysupport",
  },
  {
    id: 218,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add New Variations",
      et: "Lisa variatsioone",
      lv: "Add New Variations",
      fi: "Lisää uusia variaatioita",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addNewVariations",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348039,
    addedby: "prince.ajuobi@er",
    changed: 1612443122,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 219,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Dimension 1",
      et: "1. dimensioon",
      lv: "Dimension 1",
      fi: "1. ulottuvuus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "dimension1",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348087,
    addedby: "prince.ajuobi@er",
    changed: 1612443113,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 220,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Dimension 2",
      et: "2. dimensioon",
      lv: "Dimension 2",
      fi: "2. ulottuvuus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "dimension2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348122,
    addedby: "prince.ajuobi@er",
    changed: 1612443108,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 221,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Dimension 3",
      et: "3. dimensioon",
      lv: "Dimension 3",
      fi: "3. ulottuvuus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "dimension3",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348149,
    addedby: "prince.ajuobi@er",
    changed: 1612443100,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 222,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Variations",
      et: "Variatsioonid",
      lv: "Variations",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "variations",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348307,
    addedby: "prince.ajuobi@er",
    changed: 1601280042,
    changedby: "erplysupport",
  },
  {
    id: 223,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Variations",
      et: "Tootevariatsioonid",
      lv: "Product Variations",
      fi: "Tuotevariaatiot",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productVariations",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348446,
    addedby: "prince.ajuobi@er",
    changed: 1612443129,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 224,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Please select at least one variation",
      et: "Palun vali vähemalt üks variatsioon",
      lv: "Please select at least one variation",
      fi: "Valitse vähintään yksi variaatio",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "selectVariation",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348489,
    addedby: "prince.ajuobi@er",
    changed: 1612443135,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 225,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix Product Variations",
      et: "Maatrikstoote variatsioonid",
      lv: "Matrix Product Variations",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matrixProductVariations",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348709,
    addedby: "prince.ajuobi@er",
    changed: 1601278164,
    changedby: "erplysupport",
  },
  {
    id: 226,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Back",
      et: "Tagasi",
      lv: "Back",
      fi: "Takaisin",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "back",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348786,
    addedby: "prince.ajuobi@er",
    changed: 1612443023,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 227,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Approve",
      et: "Kinnita",
      lv: "Approve",
      fi: "Hyväksy",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "approve",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348801,
    addedby: "prince.ajuobi@er",
    changed: 1612443027,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 228,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Generate Variations",
      et: "Genereeri variatsioonid",
      lv: "Generate Variations",
      fi: "Luo variaatiot",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "generateVariations",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600348887,
    addedby: "prince.ajuobi@er",
    changed: 1612443039,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 229,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Please select variation",
      et: "Palun vali variatsioon",
      lv: "Please select variation",
      fi: "Valitse variaatio",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "selectAVariation",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600349163,
    addedby: "prince.ajuobi@er",
    changed: 1612443046,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 230,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Adding products",
      et: "Toodete lisamine",
      lv: "Adding products",
      fi: "Lisää tuotteita",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addingProducts",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600351795,
    addedby: "prince.ajuobi@er",
    changed: 1612443058,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 231,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Upload Product Codes",
      et: "Laadi üles tootekoodid",
      lv: "Upload Product Codes",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "uploadProductCodes",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600351826,
    addedby: "prince.ajuobi@er",
    changed: 1601278128,
    changedby: "erplysupport",
  },
  {
    id: 232,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Open File Dialog",
      et: "Ava failivaliku aken",
      lv: "Open File Dialog",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "openFileDialog",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600352243,
    addedby: "prince.ajuobi@er",
    changed: 1601888003,
    changedby: "randma@erply.com",
  },
  {
    id: 233,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "File extension must be .csv. First line of the file must contain keyword “productld”, followed by product IDs, each one on a separate line.",
      et: "Faililaiend peab olema .csv. Faili esimesel real peab olema märksõna „productId” ning selle järel toodete ID-d, igaüks omaette real.",
      lv: "File extension must be .csv. First line of the file must contain keyword “productld”, followed by product IDs, each one on a separate line.",
      fi: "Tiedostotunnisteen on oltava .csv. Tiedoston ensimmäisellä rivillä on oltava avainsana “productld”, jota seuraa tuoteID:t, kukin erillisellä rivillä.",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "allowedFileExtension",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600352305,
    addedby: "prince.ajuobi@er",
    changed: 1620893152,
    changedby: "erplysupport",
  },
  {
    id: 234,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add items to",
      et: "Lisa tooteid sortimenti",
      lv: "Add items to",
      fi: "Lisää tuotteet valikoimaan",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addItemsTo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600352941,
    addedby: "prince.ajuobi@er",
    changed: 1612442808,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 235,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Done",
      et: "Valmis",
      lv: "Done",
      fi: "Valmis",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "done",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1600353065,
    addedby: "prince.ajuobi@er",
    changed: 1612442798,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 294,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Create new product",
      et: "Loo uus toode",
      lv: "Create new product",
      fi: "Luo uusi tuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "createNewProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1601459500,
    addedby: "prince.ajuobi@er",
    changed: 1612442882,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 295,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Save Product",
      et: "Salvesta toode",
      lv: "Save Product",
      fi: "Tallenna tuote",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "saveProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1601459548,
    addedby: "prince.ajuobi@er",
    changed: 1612442875,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 307,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product group is required",
      et: "Tootekood ja tootegrupp on kohustuslikud",
      lv: "Product group is required",
      fi: "Tuoteryhmä on pakollinen",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "newProductOperation",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1601478394,
    addedby: "prince.ajuobi@er",
    changed: 1612450353,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 418,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Pictures",
      et: "Pildid",
      lv: "Pictures",
      fi: "Tuotteen kuvat",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "pictures",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1602679464,
    addedby: "prince.ajuobi@er",
    changed: 1612440677,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 419,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product image",
      et: "Tootepilt",
      lv: "Product image",
      fi: "Tuotteen kuva",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productImge",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1602679485,
    addedby: "prince.ajuobi@er",
    changed: 1621319459,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 420,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product image uploader",
      et: "Tootepiltide üleslaadija",
      lv: "Product image uploader",
      fi: "Tuotteen kuvan lisäys",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productImageUpload",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1602833396,
    addedby: "prince.ajuobi@er",
    changed: 1621319484,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 421,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "search supplier",
      et: "Otsi hankijat",
      lv: "search supplier",
      fi: "Etsi toimittajaa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "searchSupplier",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603296735,
    addedby: "prince.ajuobi@er",
    changed: 1612440658,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 422,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product extra field 1",
      et: "Lisaväli 1",
      lv: "Product extra field 1",
      fi: "Tuotteen lisäkenttä numero 1",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "extraField1",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971033,
    addedby: "prince.ajuobi@er",
    changed: 1612440618,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 423,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product extra field 2",
      et: "Lisaväli 2",
      lv: "Product extra field 2",
      fi: "Tuotteen lisäkenttä numero 2",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "extraField2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971060,
    addedby: "prince.ajuobi@er",
    changed: 1621319754,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 424,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product extra field 3",
      et: "Lisaväli 3",
      lv: "Product extra field 3",
      fi: "Tuotteen lisäkenttä numero 3",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "extraField3",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971082,
    addedby: "prince.ajuobi@er",
    changed: 1621319760,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 425,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product extra field 4",
      et: "Lisaväli 4",
      lv: "Product extra field 4",
      fi: "Tuotteen lisäkenttä numero 4",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "extraField4",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971098,
    addedby: "prince.ajuobi@er",
    changed: 1621319765,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 426,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Enable extra field 1",
      et: "Aktiveeri lisaväli 1",
      lv: "Enable extra field 1",
      fi: "Ota lisäkenttä 1 käyttöön",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "enableExtraField1",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971222,
    addedby: "prince.ajuobi@er",
    changed: 1612440649,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 427,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Enable extra field 2",
      et: "Aktiveeri lisaväli 2",
      lv: "Enable extra field 2",
      fi: "Ota lisäkenttä 2 käyttöön",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "enableExtraField2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971247,
    addedby: "prince.ajuobi@er",
    changed: 1612440644,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 428,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Enable extra field 3",
      et: "Aktiveeri lisaväli 3",
      lv: "Enable extra field 3",
      fi: "Ota lisäkenttä 3 käyttöön",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "enableExtraField3",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971263,
    addedby: "prince.ajuobi@er",
    changed: 1612440637,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 429,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Enable extra field 4",
      et: "Aktiveeri lisaväli 4",
      lv: "Enable extra field 4",
      fi: "Ota lisäkenttä 4 käyttöön",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "enableExtraField4",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971284,
    addedby: "prince.ajuobi@er",
    changed: 1612440630,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 430,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: ' The field can be assigned a custom name. By default it will be labeled on forms as "Product extra field 1".',
      et: 'Väljale saab määrata kohandatud nime. Vaikimisi on välja nimetus "Lisaväli 1".',
      lv: ' The field can be assigned a custom name. By default it will be labeled on forms as "Product extra field 1".',
      fi: 'Tälle kentälle voidaan antaa oma nimi. Oletuksena se merkitään sarakkeisiin nimellä "Tuotteen lisäkenttä numero 1".',
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "extraField1Msg",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971329,
    addedby: "prince.ajuobi@er",
    changed: 1621320516,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 431,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: 'The field can be assigned a custom name. By default it will be labeled on forms as "Product extra field 2".',
      et: 'Väljale saab määrata kohandatud nime. Vaikimisi on välja nimetus "Lisaväli 2".',
      lv: 'The field can be assigned a custom name. By default it will be labeled on forms as "Product extra field 2".',
      fi: 'Tälle kentälle voidaan antaa oma nimi. Oletuksena se merkitään sarakkeisiin nimellä "Tuotteen lisäkenttä numero 2".',
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "extraField2Msg",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971366,
    addedby: "prince.ajuobi@er",
    changed: 1621320509,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 432,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: 'The field can be assigned a custom name. By default it will be labeled  on forms as "Product extra field 3".',
      et: 'Väljale saab määrata kohandatud nime. Vaikimisi on välja nimetus "Lisaväli 3".',
      lv: 'The field can be assigned a custom name. By default it will be labeled  on forms as "Product extra field 3".',
      fi: 'Tälle kentälle voidaan antaa oma nimi. Oletuksena se merkitään sarakkeisiin nimellä "Tuotteen lisäkenttä numero 3".',
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "extraField3Msg",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971394,
    addedby: "prince.ajuobi@er",
    changed: 1621320503,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 433,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: 'The field can be assigned a custom name. By default it will be labeled on forms as "Product extra field 4".',
      et: 'Väljale saab määrata kohandatud nime. Vaikimisi on välja nimetus "Lisaväli 4".',
      lv: 'The field can be assigned a custom name. By default it will be labeled on forms as "Product extra field 4".',
      fi: 'Tälle kentälle voidaan antaa oma nimi. Oletuksena se merkitään sarakkeisiin nimellä "Tuotteen lisäkenttä numero 4".',
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "extraField4Msg",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971418,
    addedby: "prince.ajuobi@er",
    changed: 1621320497,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 434,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Field Label",
      et: "",
      lv: "Field Label",
      fi: "Kentän otsikko",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "fieldLabel",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603971524,
    addedby: "prince.ajuobi@er",
    changed: 1612440446,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 435,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add field item",
      et: "",
      lv: "Add field item",
      fi: "Lisää kenttä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addField",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603972577,
    addedby: "prince.ajuobi@er",
    changed: 1612440439,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 436,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Active",
      et: "Aktiivne",
      lv: "Active",
      fi: "Aktiivinen",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "isActive",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1603972720,
    addedby: "prince.ajuobi@er",
    changed: 1612440417,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 437,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Field Items",
      et: "",
      lv: "Field Items",
      fi: "Kentän kohteet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "filedItems",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604050488,
    addedby: "prince.ajuobi@er",
    changed: 1612440432,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 438,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Code 5",
      et: "Kood 5",
      lv: "Code 5",
      fi: "Koodi 5",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "code5",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604061170,
    addedby: "prince.ajuobi@er",
    changed: 1612440395,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 439,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Code 6",
      et: "Kood 6",
      lv: "Code 6",
      fi: "Koodi 6",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "code6",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604061181,
    addedby: "prince.ajuobi@er",
    changed: 1612440391,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 440,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Code 7 ",
      et: "Kood 7",
      lv: "Code 7 ",
      fi: "Koodi 7",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "code7",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604061207,
    addedby: "prince.ajuobi@er",
    changed: 1612440386,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 441,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Code 8",
      et: "Kood 8",
      lv: "Code 8",
      fi: "Koodi 8",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "code8",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604061218,
    addedby: "prince.ajuobi@er",
    changed: 1612440380,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 442,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "What is the next product code?",
      et: "Järgmine tootekood:",
      lv: "What is the next product code?",
      fi: "Seuraava tuotekoodi:",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "nextProductCode",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604396081,
    addedby: "prince.ajuobi@er",
    changed: 1621319634,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 443,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Settings",
      et: "Seaded",
      lv: "Settings",
      fi: "Asetukset",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "settings",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604396130,
    addedby: "prince.ajuobi@er",
    changed: 1621319287,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 444,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Generate EANs/UPCs automatically",
      et: "Genereeri EAN-id automaatselt",
      lv: "Generate EANs/UPCs automatically",
      fi: "Luo EAN koodit automaattisesti",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "EANAuto",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604402958,
    addedby: "prince.ajuobi@er",
    changed: 1612440362,
    changedby: "tomi.leskinen@er",
  },
  {
    id: 445,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "What is the next EAN / UPC ?",
      et: "Järgmine EAN kood:",
      lv: "What is the next EAN / UPC ?",
      fi: "Seuraava EAN koodi:",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "nextEANCode",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604403008,
    addedby: "prince.ajuobi@er",
    changed: 1621319643,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 446,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Settings",
      et: "Toote sätted",
      lv: "Product Settings",
      fi: "Tuote asetukset",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productSettings",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604403089,
    addedby: "prince.ajuobi@er",
    changed: 1621319440,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 447,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Status in assortment",
      et: "Staatus sortimendis",
      lv: "Status in assortment",
      fi: "Tila valikoimassa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "statusInAssortment",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1604568777,
    addedby: "prince.ajuobi@er",
    changed: 1621319281,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 448,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "A new version has been released.",
      et: "Toimunud on versiooniuuendus.",
      lv: "A new version has been released.",
      fi: "Uusi versiopäivitys!",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "newVersion",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1605176934,
    addedby: "prince.ajuobi@er",
    changed: 1650885628,
    changedby: "erplysupport",
  },
  {
    id: 449,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Refresh",
      et: "Uuenda",
      lv: "Refresh",
      fi: "Päivitä",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "refresh",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1605177176,
    addedby: "prince.ajuobi@er",
    changed: 1621319357,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 452,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Age Restriction",
      et: "Vanusepiirang",
      lv: "Age Restriction",
      fi: "Ikäraja",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "ageRestriction",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1605600886,
    addedby: "prince.ajuobi@er",
    changed: 1667333885,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 466,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Apply bulk change",
      et: "Rakenda massmuudatus",
      lv: "Apply bulk change",
      fi: "Hyväksy massamuutokset",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "applyBulkChange",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1611768809,
    addedby: "prince.ajuobi@er",
    changed: 1621320263,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 467,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Please select product(s) to edit",
      et: "Palun vali muudetavad tooted",
      lv: "Please select product(s) to edit",
      fi: "Valitse muokattavat tuotteet",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "selectProductToEdit",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1611768887,
    addedby: "prince.ajuobi@er",
    changed: 1650885456,
    changedby: "erplysupport",
  },
  {
    id: 468,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Bulk product edit",
      et: "Massmuudatus",
      lv: "Bulk product edit",
      fi: "Tuotteiden massa muokkaus",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "bulkProductEdit",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1611768998,
    addedby: "prince.ajuobi@er",
    changed: 1621318841,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 469,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product name in assortment",
      et: "Toote nimetus sortimendis",
      lv: "Product name in assortment",
      fi: "Tuotteen nimi valikoimassa",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productNameInAssortment",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1612264936,
    addedby: "prince.ajuobi@er",
    changed: 1621319450,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 471,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Recipe Cost",
      et: "Retsepti kulu",
      lv: "Recipe Cost",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "recipeCost",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1612975030,
    addedby: "prince.ajuobi@er",
    changed: 1621320455,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 472,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Recipe Total Cost",
      et: "Retsepti kogukulu",
      lv: "Recipe Total Cost",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "recipeTotalCost",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1612976749,
    addedby: "prince.ajuobi@er",
    changed: 1621319422,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 473,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Export",
      et: "Ekspordi tooted",
      lv: "Product Export",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productExport",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1613555536,
    addedby: "prince.ajuobi@er",
    changed: 1621319508,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 474,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Export",
      et: "Ekspordi",
      lv: "Export",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "export",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1613555688,
    addedby: "prince.ajuobi@er",
    changed: 1621319776,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 475,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Tax Rates",
      et: "Maksumäärad",
      lv: "Tax Rates",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "vatRates",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1613555792,
    addedby: "prince.ajuobi@er",
    changed: 1621320322,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 476,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Warehouses",
      et: "Laod",
      lv: "Warehouses",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "warehouses",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1613555856,
    addedby: "prince.ajuobi@er",
    changed: 1621319000,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 477,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Assortment Export",
      et: "Ekspordi sortiment",
      lv: "Assortment Export",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "assortmentProductsExport",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1613555954,
    addedby: "prince.ajuobi@er",
    changed: 1650885398,
    changedby: "erplysupport",
  },
  {
    id: 478,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Exports",
      et: "Ekspordid",
      lv: "Exports",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "exports",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1613555997,
    addedby: "prince.ajuobi@er",
    changed: 1621319785,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 479,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Apply Filters",
      et: "Rakenda filtrid",
      lv: "Apply Filters",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "applyFilters",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1613556613,
    addedby: "prince.ajuobi@er",
    changed: 1621319867,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 480,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "QuickBooks Debit Account",
      et: "Deebetkonto QuickBooksis",
      lv: "QuickBooks Debit Account",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "quickBooksDebitAccount",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1614068222,
    addedby: "prince.ajuobi@er",
    changed: 1650885370,
    changedby: "erplysupport",
  },
  {
    id: 481,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "QuickBooks Credit Account",
      et: "Kreeditkonto QuickBooksis",
      lv: "QuickBooks Credit Account",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "quickBooksCreditAccount",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1614068263,
    addedby: "prince.ajuobi@er",
    changed: 1650885360,
    changedby: "erplysupport",
  },
  {
    id: 482,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "For each item purchased from this product group, customer collects",
      et: "Iga sellesse tootegruppi kuuluva toote eest kogub klient:",
      lv: "For each item purchased from this product group, customer collects",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "customerRewards",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1614068404,
    addedby: "prince.ajuobi@er",
    changed: 1621320434,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 483,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Promotion discounts do not apply to this product group and sub-groups",
      et: "Sellele tootegrupile ja alamgrupile ei kehti kampaaniasoodustused",
      lv: "Promotion discounts do not apply to this product group and sub-groups",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "noDiscountForGroupAndSubGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1614068444,
    addedby: "prince.ajuobi@er",
    changed: 1650885347,
    changedby: "erplysupport",
  },
  {
    id: 484,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Warehouses and tax rates",
      et: "Kaupluste maksumäärad",
      lv: "Warehouses and tax rates",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "warehouseAndTax",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1614068506,
    addedby: "prince.ajuobi@er",
    changed: 1650885342,
    changedby: "erplysupport",
  },
  {
    id: 485,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Tax Rate",
      et: "Maksumäär",
      lv: "Tax Rate",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "taxRate",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1614068577,
    addedby: "prince.ajuobi@er",
    changed: 1621319261,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 486,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Please select at least one product",
      et: "Palun vali vähemalt üks toode",
      lv: "Please select at least one product",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "selectProductToPrintLabel",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1616148500,
    addedby: "prince.ajuobi@er",
    changed: 1650885335,
    changedby: "erplysupport",
  },
  {
    id: 487,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Print Label",
      et: "Trüki etiketid",
      lv: "Print Label",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "printLabel",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 0,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1616148551,
    addedby: "prince.ajuobi@er",
    changed: 1621319518,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 490,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Bulk Upload",
      et: "Massüleslaadimine",
      lv: "Bulk Upload",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "bulkUpload",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1620656453,
    addedby: "prince.ajuobi@er",
    changed: 1621318876,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 491,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Just test",
      et: "",
      lv: "Just test",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "5",
    code2: "40000000013",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1620727534,
    addedby: "prince.ajuobi@er",
    changed: 1620727535,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 492,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Names in Other Languages",
      et: "Nimetus teistes keeltes",
      lv: "Names in Other Languages",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "namesInOtherLang",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1621417231,
    addedby: "prince.ajuobi@er",
    changed: 1621503561,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 493,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Codes",
      et: "Koodid",
      lv: "Codes",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "codeCard",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1621417948,
    addedby: "prince.ajuobi@er",
    changed: 1621503574,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 494,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Classification",
      et: "Klassifikatsioon",
      lv: "Classification",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "classification",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1621418161,
    addedby: "prince.ajuobi@er",
    changed: 1621503779,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 495,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Delivery",
      et: "Tarneinfo",
      lv: "Delivery",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "delivery",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1621418263,
    addedby: "prince.ajuobi@er",
    changed: 1621503639,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 496,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Sales And Pricing",
      et: "Müügiinfo",
      lv: "Sales And Pricing",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "salesAndPricing",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1621418395,
    addedby: "prince.ajuobi@er",
    changed: 1621503671,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 497,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Details",
      et: "Detailid",
      lv: "Details",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "detailsCard",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1621418506,
    addedby: "prince.ajuobi@er",
    changed: 1621503730,
    changedby: "heleri.roosimaa@",
  },
  {
    id: 500,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Full-Size",
      et: "Täissuurus",
      lv: "Full-Size",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "full",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1624961108,
    addedby: "prince.ajuobi@er",
    changed: 1650885181,
    changedby: "erplysupport",
  },
  {
    id: 501,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Created Date",
      et: "Loomise kuupäev",
      lv: "Created Date",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "createdDate",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1626434350,
    addedby: "prince.ajuobi@er",
    changed: 1650885175,
    changedby: "erplysupport",
  },
  {
    id: 502,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix Product Export",
      et: "Maatrikstoodete eksport",
      lv: "Matrix Product Export",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matrixProductExport",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1627305810,
    addedby: "prince.ajuobi@er",
    changed: 1650885167,
    changedby: "erplysupport",
  },
  {
    id: 504,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Reorder Points",
      et: "Soovit. kogused",
      lv: "Reorder Points",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "reorderPoints",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1630409949,
    addedby: "prince.ajuobi@er",
    changed: 1650885160,
    changedby: "erplysupport",
  },
  {
    id: 505,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Select Location",
      et: "Vali ladu",
      lv: "Select Location",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "selectLocation",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1630409988,
    addedby: "prince.ajuobi@er",
    changed: 1650885135,
    changedby: "erplysupport",
  },
  {
    id: 506,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Select Product(s)",
      et: "Vali toode / tooted",
      lv: "Select Product(s)",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "selectProducts",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1630410160,
    addedby: "prince.ajuobi@er",
    changed: 1650885126,
    changedby: "erplysupport",
  },
  {
    id: 507,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Selected product",
      et: "Valitud toode",
      lv: "Selected product",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "selectedProductFran",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1630419117,
    addedby: "prince.ajuobi@er",
    changed: 1650885119,
    changedby: "erplysupport",
  },
  {
    id: 508,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Reorder point",
      et: "Miinimumkogus",
      lv: "Reorder point",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "reorderPoint",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1630419144,
    addedby: "prince.ajuobi@er",
    changed: 1650885112,
    changedby: "erplysupport",
  },
  {
    id: 509,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Restock level",
      et: "Soovituslik kogus",
      lv: "Restock level",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "restockLevel",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1630419163,
    addedby: "prince.ajuobi@er",
    changed: 1650885074,
    changedby: "erplysupport",
  },
  {
    id: 510,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Active",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "statusActive",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665683984,
    addedby: "prince.ajuobi@er",
    changed: 1665683984,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 511,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Archived",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "statusArchived",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665684053,
    addedby: "prince.ajuobi@er",
    changed: 1665684053,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 512,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "No longer ordered",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "statusNoLongerOrdered",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665684087,
    addedby: "prince.ajuobi@er",
    changed: 1665684087,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 513,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Not for sale",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "statusNotForSale",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665684115,
    addedby: "prince.ajuobi@er",
    changed: 1665684115,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 514,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "typeMatrix",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665684145,
    addedby: "prince.ajuobi@er",
    changed: 1665684145,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 515,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Bundle",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "typeBundle",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665684165,
    addedby: "prince.ajuobi@er",
    changed: 1665684165,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 516,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Assembly",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "typeAssembly",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665684189,
    addedby: "prince.ajuobi@er",
    changed: 1665684189,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 517,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "typeProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665684214,
    addedby: "prince.ajuobi@er",
    changed: 1665684214,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 518,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "All except archived",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "statusAllExpectArchived",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665685260,
    addedby: "prince.ajuobi@er",
    changed: 1665690472,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 519,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Code generated automatically",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "codeGeneratedAutomatically",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665690415,
    addedby: "prince.ajuobi@er",
    changed: 1665690415,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 520,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "EAN/UPC generated automatically",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "EANGeneratedAutomatically",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665690699,
    addedby: "prince.ajuobi@er",
    changed: 1665690699,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 521,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add new",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addNew",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665691325,
    addedby: "prince.ajuobi@er",
    changed: 1665691325,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 522,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Pictures in Erply CDN",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "picturesInErplyCDN",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665691861,
    addedby: "prince.ajuobi@er",
    changed: 1665691861,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 523,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Pictures in Erply API",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "picturesInErplyAPI",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665691908,
    addedby: "prince.ajuobi@er",
    changed: 1665691908,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 524,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Pictures in this tab sync to WooCommerce and Shopz. When building new integrations, we recommend to upload pictures here. These pictures can be retrieved from",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "cdnUploadImageInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665692101,
    addedby: "prince.ajuobi@er",
    changed: 1665692101,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 525,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "All pictures are publicly accessible (do not require an Erply user name and password to access).",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "cdnUploadImageInfo2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665692185,
    addedby: "prince.ajuobi@er",
    changed: 1665692185,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 526,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product image",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productImage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665692322,
    addedby: "prince.ajuobi@er",
    changed: 1665694507,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 527,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Pictures in this tab sync to Shopify and other e-commerce integrations. These pictures can be retrieved with Erply API calls",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "erplyImgeUploadInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665692499,
    addedby: "prince.ajuobi@er",
    changed: 1665692499,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 528,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "If accessing these files does not work, please contact Erply customer support to lift the access restriction.",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "erplyImgeUploadInfo2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665692588,
    addedby: "prince.ajuobi@er",
    changed: 1665692588,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 529,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "All pictures are publicly accessible (do not require an Erply user name and password to access).",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "erplyImgeUploadInfo3",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665692662,
    addedby: "prince.ajuobi@er",
    changed: 1665692700,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 530,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Drag & Drop your images here or click to browse",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "dragAndDropInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665692868,
    addedby: "prince.ajuobi@er",
    changed: 1665692868,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 531,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "and",
      et: "ja",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "and",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665692953,
    addedby: "prince.ajuobi@er",
    changed: 1665693057,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 532,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Files in Erply CDN",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "filesInErplyCDN",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665693137,
    addedby: "prince.ajuobi@er",
    changed: 1665693137,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 533,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Files in Erply API",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "filesInErplyAPI",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665693178,
    addedby: "prince.ajuobi@er",
    changed: 1665693178,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 534,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "When building new integrations, we recommend to upload product files here. These files can be retrieved from",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "cdnFilesUploadInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665693341,
    addedby: "prince.ajuobi@er",
    changed: 1665693341,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 535,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "All files are publicly accessible (do not require an Erply user name and password to access).",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "cdnFilesUploadInfo2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665693397,
    addedby: "prince.ajuobi@er",
    changed: 1665693397,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 536,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "These files can be retrieved with Erply API calls",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "erplyFileUpload",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665693510,
    addedby: "prince.ajuobi@er",
    changed: 1665693510,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 537,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "If accessing the files does not work, please contact Erply customer support to lift the access restriction, or consider using the CDN instead.",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "erplyFileUpload2",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665693660,
    addedby: "prince.ajuobi@er",
    changed: 1665693660,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 538,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "All files are publicly accessible (do not require an Erply user name and password to access).",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "erplyFileUpload3",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665693785,
    addedby: "prince.ajuobi@er",
    changed: 1665693785,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 539,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Drag & Drop your files here or click to browse",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "dragAndDropFiles",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665693901,
    addedby: "prince.ajuobi@er",
    changed: 1665693901,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 540,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "File type",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "fileType",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665694075,
    addedby: "prince.ajuobi@er",
    changed: 1665694075,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 541,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Information file",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "informationFile",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665694159,
    addedby: "prince.ajuobi@er",
    changed: 1665694159,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 542,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Download file",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "downloadFile",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1665694236,
    addedby: "prince.ajuobi@er",
    changed: 1665694236,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 543,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Please enter the next EAN / UPC value WITHOUT the last digit. The last digit is always a check digit, and must be automatically derived from the previous ones. Thus, generated codes will always be one digit longer than the value entered here.",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "eanSettingInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667333669,
    addedby: "prince.ajuobi@er",
    changed: 1667347477,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 544,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Alcohol percentage",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "alcoholPercentage",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667334008,
    addedby: "prince.ajuobi@er",
    changed: 1667334008,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 545,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Alcohol registry number",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "alcoholRegistryNumber",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667334074,
    addedby: "prince.ajuobi@er",
    changed: 1667334074,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 546,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Batches",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "batches",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667334117,
    addedby: "prince.ajuobi@er",
    changed: 1667334117,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 547,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product brand",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productBrand",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667334177,
    addedby: "prince.ajuobi@er",
    changed: 1667334177,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 548,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product category",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productCategory",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667334265,
    addedby: "prince.ajuobi@er",
    changed: 1667334265,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 549,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Delivery time",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "deliveryTime",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667334469,
    addedby: "prince.ajuobi@er",
    changed: 1667334469,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 550,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Deposit fee amount",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "depositFeeAmount",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667334533,
    addedby: "prince.ajuobi@er",
    changed: 1667334533,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 551,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Excise declaration number",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "exciseDeclarationNumber",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667334784,
    addedby: "prince.ajuobi@er",
    changed: 1667334784,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 552,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product family",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productFamily",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335036,
    addedby: "prince.ajuobi@er",
    changed: 1667335036,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 553,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Gift card",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "giftCard",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335267,
    addedby: "prince.ajuobi@er",
    changed: 1667335267,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 554,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Regualar gift card",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "regularGiftCard",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335317,
    addedby: "prince.ajuobi@er",
    changed: 1667335317,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 555,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Labels not needed",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "labelsNotNeeded",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335372,
    addedby: "prince.ajuobi@er",
    changed: 1667335372,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 556,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Location in warehouse",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "locationInWarehouse",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335455,
    addedby: "prince.ajuobi@er",
    changed: 1667335455,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 557,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Location in warehouse text",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "locationInWarehouseText",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335516,
    addedby: "prince.ajuobi@er",
    changed: 1667335516,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 558,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Manufacturer name",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "manuName",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335562,
    addedby: "prince.ajuobi@er",
    changed: 1667335562,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 559,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Non discountable",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "nonDiscountable",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335689,
    addedby: "prince.ajuobi@er",
    changed: 1667335689,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 560,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Non refu",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "nonRefundableLabel",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335818,
    addedby: "prince.ajuobi@er",
    changed: 1667335818,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 561,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Non stock product",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "nonStockProduct",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335847,
    addedby: "prince.ajuobi@er",
    changed: 1667335847,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 562,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Packaging type",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "packagingType",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335904,
    addedby: "prince.ajuobi@er",
    changed: 1667335904,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 563,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Price",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "priceLable",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667335984,
    addedby: "prince.ajuobi@er",
    changed: 1667335984,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 564,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product reorder multiples",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productReorderMultiples",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667336160,
    addedby: "prince.ajuobi@er",
    changed: 1667336160,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 565,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Reward point not allowed",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "rewardPointNotAllowed",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667336482,
    addedby: "prince.ajuobi@er",
    changed: 1667336482,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 566,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Supplier code",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "supplierCode",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667343056,
    addedby: "prince.ajuobi@er",
    changed: 1667343056,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 567,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Tax free",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "taxFree",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667343121,
    addedby: "prince.ajuobi@er",
    changed: 1667343121,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 568,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Set matrix variations product fields to be inherited from their parent product",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "variationSettingsInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667343393,
    addedby: "prince.ajuobi@er",
    changed: 1667343393,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 569,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Select all",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "selectAll",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667343459,
    addedby: "prince.ajuobi@er",
    changed: 1667343459,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 570,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Price with VAT",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "priceWithVAT",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667344897,
    addedby: "prince.ajuobi@er",
    changed: 1667344897,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 571,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Supplier name",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "supplierName",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345045,
    addedby: "prince.ajuobi@er",
    changed: 1667345045,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 572,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Manage product fields permission for a specific user group",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "settingProductFieldsInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345206,
    addedby: "prince.ajuobi@er",
    changed: 1667345206,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 573,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Select user group",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "selectUserGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345261,
    addedby: "prince.ajuobi@er",
    changed: 1667345261,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 574,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "View",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "view",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345362,
    addedby: "prince.ajuobi@er",
    changed: 1667345362,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 575,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product codes must be unique",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "uniqueProductCode",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345457,
    addedby: "prince.ajuobi@er",
    changed: 1667345457,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 576,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "UPC codes must be unique",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "uniqueUPC",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345506,
    addedby: "prince.ajuobi@er",
    changed: 1667345506,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 577,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: '"Show in webshop" is checked by default for new products and product groups',
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "showInWebshopCheckedByDefault",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345566,
    addedby: "prince.ajuobi@er",
    changed: 1667345566,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 578,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: '"Cross-sell" relationship works one way only',
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "crossSellOneWay",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345619,
    addedby: "prince.ajuobi@er",
    changed: 1667345619,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 579,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Matrix Variations",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "matroxVariations",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345748,
    addedby: "prince.ajuobi@er",
    changed: 1667345748,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 580,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Product Fields Permission",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "productFieldsPermission",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345800,
    addedby: "prince.ajuobi@er",
    changed: 1667345800,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 581,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Inventory and Purchase",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "inventoryAndPurchase",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667345841,
    addedby: "prince.ajuobi@er",
    changed: 1667345841,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 582,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Brand form",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "brandForm",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667346011,
    addedby: "prince.ajuobi@er",
    changed: 1667346011,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 583,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Group form",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "groupForm",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667346488,
    addedby: "prince.ajuobi@er",
    changed: 1667346488,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 584,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "rewards point per 1 USD",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "rewardsPointInfo",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667346596,
    addedby: "prince.ajuobi@er",
    changed: 1667346596,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 585,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Bulk Copy Reorder Points and Restock Levels",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "bulkCopy",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667346791,
    addedby: "prince.ajuobi@er",
    changed: 1667346791,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 586,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Store (All Products)",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "storeAllProducts",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667346836,
    addedby: "prince.ajuobi@er",
    changed: 1667346836,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 587,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Source",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "source",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667346877,
    addedby: "prince.ajuobi@er",
    changed: 1667346877,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 588,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Destination",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "destination",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667346917,
    addedby: "prince.ajuobi@er",
    changed: 1667346917,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 589,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Copy reorder points and restock levels for all products",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "copyReorderPoints",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667346956,
    addedby: "prince.ajuobi@er",
    changed: 1667346956,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 590,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "All stores (Selected Products)",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "allStores",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667347016,
    addedby: "prince.ajuobi@er",
    changed: 1667347016,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 591,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Add selected",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "addSelected",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667347082,
    addedby: "prince.ajuobi@er",
    changed: 1667347082,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 592,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "No product(s) selected",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "noProductSelected",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667347144,
    addedby: "prince.ajuobi@er",
    changed: 1667347144,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 593,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Copy reorder points and restock levels to all locations",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "copyReorderPointsAllLocations",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667347245,
    addedby: "prince.ajuobi@er",
    changed: 1667347245,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 594,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "User group",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "userGroup",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667347584,
    addedby: "prince.ajuobi@er",
    changed: 1667347584,
    changedby: "prince.ajuobi@er",
  },
  {
    id: 595,
    type: "PRODUCT",
    group_id: 1,
    unit_id: 0,
    name: {
      en: "Save changes",
      et: "",
      lv: "",
      fi: "",
    },
    description: {
      en: {
        plain_text: "",
        html: "",
      },
      et: {
        plain_text: "",
        html: "",
      },
      lv: {
        plain_text: "",
        html: "",
      },
      ru: {
        plain_text: "",
        html: "",
      },
      fi: {
        plain_text: "",
        html: "",
      },
    },
    code: "saveChangesPIM",
    code2: "",
    code3: "",
    code5: "",
    code6: "",
    code7: "",
    code8: "",
    extra_field1_id: 0,
    extra_field2_id: 0,
    extra_field3_id: 0,
    extra_field4_id: 0,
    supplier_code: "",
    tax_rate_id: 1,
    price: 0,
    suggested_retail_price: 0,
    price_with_tax: 0,
    net_weight: 0,
    gross_weight: 0,
    length: 0,
    width: 0,
    height: 0,
    is_gift_card: 0,
    non_discountable: 0,
    non_refundable: 0,
    volume: 0,
    category_id: 0,
    brand_id: 0,
    supplier_id: 0,
    priority_group_id: 0,
    country_of_origin_id: 0,
    manufacturer_name: "",
    cost: 0,
    status: "ACTIVE",
    displayed_in_webshop: 1,
    sold_in_packages: 0,
    location_in_warehouse_id: 0,
    location_in_warehouse_text: "",
    parent_product_id: 0,
    deposit_fee_id: 0,
    family_id: 0,
    age_restriction: 0,
    packing_not_required: 0,
    has_serial_numbers: 0,
    delivery_time: "",
    packaging_type: "",
    alcohol_registry_number: "",
    alcohol_percentage: "",
    batches: "",
    excise_declaration_number: "",
    tax_free: 0,
    is_regular_gift_card: 0,
    reward_points_not_allowed: 0,
    non_stock_product: 0,
    cashier_must_enter_price: 0,
    labels_not_needed: 0,
    deposit_fee_amount: 0,
    product_reorder_multiples: 0,
    added: 1667347746,
    addedby: "prince.ajuobi@er",
    changed: 1667347746,
    changedby: "prince.ajuobi@er",
  },
];
